<template>
  <div class="setting">
    <!-- 导航栏区域 -->
    <van-nav-bar class="nav_bar" title="设置" placeholder fixed @click-left="$router.go(-1)">
      <template slot="left">
        <van-icon class="left_arrow" name="arrow-left" />
      </template>
    </van-nav-bar>
    <!-- 导航栏区域 -->
    <van-cell-group>
      <van-field input-align="right" v-model="userInfo.nickname" label="姓名" right-icon="arrow" placeholder="请输入姓名" readonly @click="showNickName = true" />
      <!-- <van-field input-align="right" v-model="userInfo.sex" label="性别" right-icon="arrow" placeholder="请选择性别" readonly @click="showsex = true" /> -->
      <!-- <van-field input-align="right" v-model="userInfo.idcard" label="身份证号" right-icon="arrow" placeholder="请输入身份证号" readonly @click="showIdcard = true" /> -->
      <!-- <van-field input-align="right" v-model="userInfo.address" label="城市" right-icon="arrow" placeholder="请输入城市" readonly @click="showWechat = true" /> -->
      <!-- <van-field input-align="right" v-model="userInfo.profession" label="申报参培项目" right-icon="arrow" placeholder="请选择申报参培项目" readonly @click="showProfession = true" /> -->
      <van-field input-align="right" v-model="userInfo.mobile" label="手机号" right-icon="arrow" placeholder="请输入手机号" readonly @click="showMobile = true" />
      <!-- 身份证上传 -->
 <!--     <van-cell title="身份证正面" center>
        <template #right-icon>
          <van-uploader
            v-model="idCardFiles"
            :after-read="uploadIdCard"
            :max-count="1"
            class="idcard-uploader"
          >
            <div class="idcard-preview">
              <img v-if="userInfo.idcard1" :src="userInfo.idcard1" class="idcard-img-container" />
              <van-icon v-else name="photo" class="idcard-img-container" />
            </div>
          </van-uploader>
        </template>
      </van-cell> -->
<!--      <van-cell title="身份证反面" center>
        <template #right-icon>
          <van-uploader
            v-model="idCardFiles1"
            :after-read="uploadIdCard2"
            :max-count="1"
            class="idcard-uploader"
          >
            <div class="idcard-preview">
              <div class="idcard-preview">
                <img v-if="userInfo.idcard2" :src="userInfo.idcard2" class="idcard-img-container" />
                <van-icon v-else name="photo" class="idcard-img-container" />
              </div>
            </div>
          </van-uploader>
        </template>
      </van-cell> -->
      <!-- 头像上传 -->
<!--      <van-cell title="国家一级社会体育指导员证书" center>
        <template #right-icon>
          <van-uploader
            v-model="avatarFile"
            :after-read="uploadAvatar"
            :max-count="1"
            class="avatar-uploader"
          >
            <div class="avatar-preview">
              <img v-if="userInfo.zhengshu" :src="userInfo.zhengshu" class="avatar-img" />
              <van-icon v-else name="photo" class="idcard-img-container" />
            </div>
          </van-uploader>
        </template>
      </van-cell> -->
    </van-cell-group>

    <!-- 修改昵称弹出层 -->
    <van-popup v-model="showNickName" position="bottom" :style="{ height: '130px' }">
      <div class="popup">
        <van-field v-model="editUserInfo.nickname" label="昵称" placeholder="请输入昵称" />
        <van-button type="primary" size="small" @click="resetUserInfo">修改</van-button>
      </div>
    </van-popup>
    <van-popup v-model="showIdcard" position="bottom" :style="{ height: '130px' }">
      <div class="popup">
        <van-field v-model="editUserInfo.idcard" label="身份证号" placeholder="请输入身份证号" />
        <van-button type="primary" size="small" @click="resetUserInfo">修改</van-button>
      </div>
    </van-popup>
    <!-- 修改职业弹出层 -->
    <van-popup v-model="showsex" position="bottom" :style="{ height: '200px' }">
      <van-picker title="性别" show-toolbar :columns="columns2" @confirm="resetUserInfo" @change="changesex" />
    </van-popup>
    <!-- 修改职业弹出层 -->
    <van-popup v-model="showProfession" position="bottom" :style="{ height: '200px' }">
      <van-picker title="申报参培项目" show-toolbar :columns="columns" @confirm="resetUserInfo" @change="changeProfession" />
    </van-popup>
    <!-- 修改手机号弹出层 -->
    <van-popup v-model="showMobile" position="bottom" :style="{ height: '30%' }">
      <div class="popup">
        <van-field v-model="editUserInfo.mobile" label="手机号" placeholder="请输入手机号" />
        <van-field v-model="sms" center clearable label="短信验证码" placeholder="请输入短信验证码">
          <template #button>
            <van-button size="small" type="primary" @click="sendSms">发送验证码</van-button>
          </template>
        </van-field>
        <van-button type="primary" size="small" @click="editUserMobile">修改</van-button>
      </div>
    </van-popup>
    <!-- 修改微信号弹出层 -->
    <van-popup v-model="showWechat" position="bottom" :style="{ height: '130px' }">
      <div class="popup">
        <van-field v-model="editUserInfo.address" label="城市" placeholder="请输入城市" />
        <van-button type="primary" size="small" @click="resetUserInfo">修改</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getUserInfo, editUserInfo, sendSms, checkSms, uploadFile } from '@/api/Mine/Setting'
import { removeItem } from '@/utils/localStorage'
export default {
  name: 'Setting',
  data() {
    return {
      // 用户信息
      // 上传相关数据
      avatarFile: [], // 头像文件
      idCardFiles: [], // 身份证文件
      idCardFiles1: [], // 身份证文件
      idCardPreviews: [], // 身份证预览图
      // 用户信息
      userInfo: {},
      columns: [],
      columnsId: [],
      sms: null,
      showNickName: false,
      showIdcard: false,
      showsex: false,
      showProfession: false,
      showMobile: false,
      showWechat: false,
      profession_list: [],
      columns2: ['请选择性别', '男', '女'],
      editUserInfo: {
        nickname: null,
        profession: null,
        mobile: null,
        idcard: null,
        sex: null,
        wechat: null
      }
    }
  },
  mounted() {
    // 获取用户信息
    this.getUserInfo()
  },
  methods: {
    // 获取用户信息
    async getUserInfo() {
      const { data } = await getUserInfo()
      this.profession_list = data.userinfo.profession_list
      this.userInfo.nickname = data.userinfo.nickname
      this.userInfo.profession = data.userinfo.profession_name
      this.userInfo.mobile = data.userinfo.mobile
      this.userInfo.wechat = data.userinfo.wechat
      this.userInfo.idcard = data.userinfo.idcard
      this.userInfo.idcard1 = data.userinfo.idcard1
      this.userInfo.idcard2 = data.userinfo.idcard2
      this.userInfo.sex = data.userinfo.sex
      this.userInfo.address = data.userinfo.address
      this.userInfo.avatar = data.userinfo.avatar
      this.userInfo.zhengshu = data.userinfo.zhengshu
      this.editUserInfo.nickname = data.userinfo.nickname
      this.editUserInfo.profession = data.userinfo.profession
      this.editUserInfo.mobile = data.userinfo.mobile
      this.editUserInfo.wechat = data.userinfo.wechat
      this.editUserInfo.idcard = data.userinfo.idcard
      this.editUserInfo.idcard1 = data.userinfo.idcard1
      this.editUserInfo.idcard2 = data.userinfo.idcard2
      this.editUserInfo.sex = data.userinfo.sex
      this.editUserInfo.address = data.userinfo.address
      this.editUserInfo.avatar = data.userinfo.avatar
      this.editUserInfo.zhengshu = data.userinfo.zhengshu
      data.userinfo.profession_list.forEach(item => {
        this.columnsId = [...this.columnsId, item.id]
        this.columns = [...this.columns, item.name]
      })
    },
    // 修改用户信息
    async resetUserInfo() {
      const res = await editUserInfo(this.editUserInfo)
      if (res.code === 1) {
        this.showNickName = false
        this.showProfession = false
        this.showMobile = false
        this.showWechat = false
        this.showIdcard = false
        this.showsex = false
        this.$toast('修改成功')
        // 获取用户信息
        this.getUserInfo()
      }
    },
    // 职业改变
    changeProfession(picker, value, index) {
      this.editUserInfo.profession = this.columnsId[index]
    },
    changesex(picker, value, index) {
      console.log(value + index)
      this.editUserInfo.sex = value
    },
    // 发送验证码
    async sendSms() {
      const res = await sendSms(this.editUserInfo.mobile)
      if (res.code === 1) {
        this.$toast('发送成功')
      } else {
        this.$toast('发送失败')
      }
    },
    // 修改手机号
    async editUserMobile() {
      const obj = {
        mobile: this.editUserInfo.mobile,
        captcha: this.sms
      }
      const res = await checkSms(obj)
      if (res.code === 1) {
        this.resetUserInfo()
      } else {
        this.$toast('验证码错误')
      }
    },
    // 上传头像
    async uploadAvatar(file) {
      this.$toast.loading('上传中...')
      try {
        const formData = new FormData()
        formData.append('file', file.file)
        formData.append('type', 'avatar')

        const res = await uploadFile(formData)
        if (res.code === 1) {
          this.userInfo.zhengshu = res.data.fullurl
          this.$toast.success('证书上传成功')
          // 更新用户信息中的头像
          this.editUserInfo.zhengshu = res.data.fullurl
          await editUserInfo({ zhengshu: res.data.fullurl })
        } else {
          this.$toast.fail('证书上传失败')
        }
      } catch (error) {
        this.$toast.fail('上传出错')
      }
    },

    // 上传身份证照片
    async uploadIdCard(file) {
      this.$toast.loading('上传中...')
      try {
        const formData = new FormData()
        formData.append('file', file.file)
        formData.append('type', 'idcard')

        const res = await uploadFile(formData)
        if (res.code === 1) {
          this.userInfo.idcard1 = res.data.fullurl
          this.$toast.success('身份证上传成功')
          this.editUserInfo.idcard1 = res.data.fullurl
          await editUserInfo({ idcard1: res.data.fullurl })
          // 保存到用户信息中（实际项目中可能需要单独接口）
          // 这里可以根据需要保存到用户信息或单独处理
        } else {
          this.$toast.fail('上传失败')
        }
      } catch (error) {
        this.$toast.fail('上传出错')
      }
    },
    async uploadIdCard2(file) {
      this.$toast.loading('上传中...')
      try {
        const formData = new FormData()
        formData.append('file', file.file)
        formData.append('type', 'idcard')

        const res = await uploadFile(formData)
        if (res.code === 1) {
          this.$toast.success('身份证上传成功')
          this.userInfo.idcard2 = res.data.fullurl
          this.editUserInfo.idcard2 = res.data.fullurl
          await editUserInfo({ idcard2: res.data.fullurl })
          // 保存到用户信息中（实际项目中可能需要单独接口）
          // 这里可以根据需要保存到用户信息或单独处理
        } else {
          this.$toast.fail('上传失败')
        }
      } catch (error) {
        this.$toast.fail('上传出错')
      }
    },
    // 退出
    exit() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '确定要退出登录吗'
        })
        .then(() => {
          removeItem('token')
          this.$toast.success('退出成功')
          this.$router.push('/Login')
        })
        .catch(() => {
          this.$toast('已取消操作')
        })
    }
  }
}
</script>
<style lang="less" scoped>
.popup {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  align-items: center;
  .van-button {
    margin-top: 30px;
    width: 200px;
  }
}
// 头像上传样式
.avatar-uploader {
  display: flex;
  justify-content: flex-end;
  padding: 8px 0;

  .avatar-preview {
    width: 60px;
    height: 60px;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    .avatar-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .avatar-icon {
      font-size: 40px;
      color: #c8c9cc;
    }
  }
}

// 身份证上传样式
.idcard-uploader {
  display: flex;
  justify-content: flex-end;
  padding: 8px 0;

  .idcard-preview {
    display: flex;
    gap: 10px;
    width: 60px;
    height: 60px;
    .idcard-img-container {
      position: relative;
      width: 80px;
      height: 50px;
      border: 1px dashed #eee;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fafafa;

      .idcard-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .idcard-icon {
        position: absolute;
        font-size: 24px;
        color: #c8c9cc;
      }
    }

    .idcard-add {
      width: 80px;
      height: 50px;
      border: 1px dashed #eee;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #969799;
      font-size: 12px;
      background-color: #fafafa;

      .van-icon {
        margin-bottom: 4px;
        font-size: 18px;
      }
    }
  }
}
</style>
